import _objectAssign from './_objectAssign';

export default typeof Object.assign === 'function' ? Object.assign : _objectAssign;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_assign.js
// module id = m99E
// module chunks = 22